<span class="badge pillbadge-status rounded-pill" [ngClass]="badgeStatusAsOrbStyleClass">
  <!-- Pill badge data -->
  @if (workflowType) {
    <span [translate]="workflowType"></span>
  }
  @if (organisationName) {
    <span>{{organisationName}}</span>
  }
  @if (workgroupName) {
    <span>{{workgroupName}}</span>
  }
  @if (clearanceLevel) {
    <span><span translate="Request.RequestTitle.Clearance"></span>: {{clearanceLevel}}</span>
  }
</span>